// Миксин для вывода результата демо-формы Стандартизации
import resultItem from "../../components/result-item";

export default {
    data() {
        return {
            fields: null,
            additionalFields: null,
        };
    },

    computed: {
        qc() {
            if (!this.activeTab) {
                return null;
            }

            if (this.result && this.result.qc in this.tabs[this.activeTab].qc) {
                return this.tabs[this.activeTab].qc[this.result.qc];
            }
            return this.tabs[this.activeTab].qc.def;
        },

        qc_complete() {
            if (this.result && "qc_complete" in this.tabs[this.activeTab]) {
                const qcCompleteValues = this.tabs[this.activeTab].qc_complete(this.result);
                if (this.result.qc_complete in qcCompleteValues) {
                    return qcCompleteValues[this.result.qc_complete];
                }
                return qcCompleteValues.def;
            }
            return false;
        },
    },

    components: { "result-item": resultItem },

    methods: {
        setFields() {
            this.setListValues();
            this.fields = this.tabs[this.activeTab].resultFields(this.result);
            this.additionalFields = null;
            if ("additionalResultFields" in this.tabs[this.activeTab]) {
                this.additionalFields = this.tabs[this.activeTab].additionalResultFields(
                    this.result,
                );
            }
        },

        setListValues() {
            if ("resultLists" in this.tabs[this.activeTab]) {
                Object.keys(this.tabs[this.activeTab].resultLists)
                    .forEach(key => {
                        if (
                            key in this.result &&
                            this.result[key] in this.tabs[this.activeTab].resultLists[key]
                        ) {
                            this.result[key] =
                            this.tabs[this.activeTab].resultLists[key][this.result[key]];
                        }
                    });
            }
        },
    },
};
